module.exports = __webpack_public_path__ + "img/logo3x.9cb21d02.png";